<template>
  <!-- prettier-ignore -->
  <div class="modal">
    <div class="modal-forms">
      <save-form
        class="modal-form"
        tiny
        :cancelable="isSaveWithoutApplicationData"
        :data="data.save"
        :is-save-without-application-data="isSaveWithoutApplicationData"
        @cancel="cancel"
        @save="data => save(data, true)"
      />

      <save-form
        v-if="!isSaveWithoutApplicationData && !existingCustomer"
        class="modal-form"
        secondary
        :data="data.send"
        @save="save"
      />
    </div>

    <div slot="footer">
      <div class="modal-disclaimer">
        <protection
          :title="$t(`${content}.basketScreenDataProtection`)"
          :toggleable="isSaveWithoutApplicationData">
          <span v-html="$t(`${content}.${disclaimerText}`)" />
        </protection>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Protection from '@/components/BasketWidget/Modals/Protection'
import SaveForm from '@/components/BasketWidget/Modals/SaveForm'

import BasketMixin from '@/mixins/Basket'

import { BasketHelper, DateTimeHelper, LogHelper, StatusHelper } from '@/helpers'

import { EVENT_BASKET_SAVED } from '@/config/events'

export default {
  name: 'BasketSaveModal',

  mixins: [BasketMixin],

  components: {
    Protection,
    SaveForm,
  },

  props: {
    isSaveWithoutApplicationData: {
      type: Boolean,
      default: false,
    },

    source: {
      type: String,
      required: true,
      validator: val => !!val,
    },
  },

  data() {
    return {
      content: 'basket.modal',
    }
  },

  computed: {
    ...mapGetters('basket', ['getPerson']),
    ...mapState(['basket']),
    ...mapState('basket', ['contractOwner', 'email', 'existingCustomer', 'mobile', 'persons']),

    data() {
      const { firstName, lastName } = this.namesOfContractOwner

      return {
        save: {
          email: this.email,
        },
        send: {
          email: this.email,
          mobile: this.mobile,
          firstName,
          lastName,
        },
      }
    },

    disclaimerText() {
      const suffix = this.isSaveWithoutApplicationData ? '' : '_B'
      return `basketScreenDataProtectionText${suffix}`
    },

    headOfContract() {
      if (this.contractOwner?.personid) {
        return this.contractOwner.personId
      } else {
        let adult
        let person = (adult = this.persons.find(p => DateTimeHelper.getAge(p.personData.dateOfBirth) >= 18))
        if (!adult) person = this.persons[0]

        return person.personId
      }
    },

    namesOfContractOwner() {
      const { firstName, lastName } = this.getPerson(this.headOfContract).personData
      return {
        firstName: firstName ?? null,
        lastName: lastName ?? null,
      }
    },
  },

  methods: {
    ...mapActions('basket', ['setBasket']),

    cancel() {
      this.$emit('canceled')
    },

    async $_getUpdatedBasket(payload) {
      // update Person
      if (payload.firstName && payload.lastName) {
        const { firstName, lastName } = payload

        const personData = Object.assign(this.getPerson(this.headOfContract).personData, { firstName, lastName })

        const personPayload = await BasketHelper.updateBasketForPerson(this.headOfContract, { personData })
        // set family name for all people, that haven't had it set yet
        personPayload.persons.map(person => {
          if (!person.personData.lastName || person.personData.lastName === null) person.personData.lastName = lastName
        })

        return BasketHelper.updateBasket(
          Object.assign({}, personPayload, { email: payload.email, mobile: payload.mobile })
        )
      } else {
        return BasketHelper.updateBasket(payload)
      }
    },

    save(payload, isTiny = false) {
      if (this.$loading.state.isLoading) {
        return
      }
      this.$loading.start()

      const params = {
        emailType: !payload.mobile ? 'OFFER_REENTRY_WITHOUT_EGATE' : 'OFFER_REENTRY',
      }

      const offerUpdate = !!StatusHelper.isOnboardingSecured(this.basket)

      return this.$_getUpdatedBasket(payload)
        .then(basket => this.updateBasket(basket, params))
        .then(basket => {
          this.$notification.add(this.$t(`${this.content}.basketSaved`))

          this.$EventBus.$emit(EVENT_BASKET_SAVED, {
            basket,
            source: isTiny ? `${this.source}-tiny` : this.source,
            update: offerUpdate,
          })
          return this.$emit('saved')
        })
        .catch(LogHelper.error)
        .finally(() => {
          this.$loading.end()
        })
    },
  },
}
</script>

<style name="mobile" scoped>
.modal {
  &-forms {
    display: flex;
    flex-direction: column;
  }

  &-disclaimer {
    padding: 15px;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .modal {
    &-forms {
      flex-direction: row;

      .modal-form {
        flex: 1 1 100%;
      }
    }
  }
}
</style>
